import { ActivityNamingRuleType, ActivityNamingTransform, ActivityNamingTransformConfig } from 'src/app/domainObjects/transformers/activityNamingTransform';
import { DataFarmType } from 'src/app/domainObjects/dataFarmType';
import { ActivityNamingTransformPreviewDataResponse } from 'src/app/messaging/activityNamingTransformPreviewDataResponse';
import { PreviewDataImportRequest } from 'src/app/messaging/previewImportDataRequest';
import { ConfigService } from 'src/app/services/config/config.service';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { TransformerViewModel } from '../../../transformer-list/transformer-list.component';
import { ActivityNamingRuleViewModel } from './activityNamingRuleViewModel';
import { TransformDetailViewModelBase } from '../../../dataTransformConfig/transformers/base/base-transformer-ui/transformDetailViewModelBase';
import { DataDictionaryService } from '../../../../services/dataDictionary/data-dictionary.service';
import { ValidationInfo, RequiredFieldValidation } from 'src/app/objectModel/validationInfo';
import { TransformerParametersViewModel } from '../transformer-parameters/transformerParametersViewModel';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { TransformType } from 'src/app/domainObjects/transformType';

export class ActivityNamingTransformDetailViewModel extends TransformDetailViewModelBase<ActivityNamingTransform> {
  farmType: DataFarmType;
  sourceColumn: string;
  targetColumn: string;
  userColumn: string;
  timeColumn?: string;
  runAll: boolean;
  deleteMisses: boolean;
  missName: string;
  
  groupBy: string;
  defContainsInclude: number;
  defTimeout: number;
  // advanced settings
  bufferRows: number;
  threads: number;
  isOpenField: string;
  isCloseField: string;
  orderField: string;
  separateBy: string;
  noGroupId: string;
  // noGroupIdTimeout: number;
  multiTargetColumn: boolean;

  rules: Array<ActivityNamingRuleViewModel> = [];

  parameters:TransformerParametersViewModel;
  dataFarm: DataFarmViewModel;
  // Preview options
  rows: number;
  sampleStart: number;
  sampleEnd: number;
  // Status
  groupHitCount?: number;
  hitCount?: number;
  missCount?: number;
  hitRatio?: number;
  hitRatioDisplay?: string;

  request: PreviewDataImportRequest;
  response: ActivityNamingTransformPreviewDataResponse;

    constructor(
      dataDictService: DataDictionaryService,
      private configService: ConfigService,
      configViewModel: DataTransformConfigViewModel,
      transformViewModel: TransformerViewModel) {
        super(dataDictService, configViewModel, transformViewModel);

        const transformConfig = this.transform.transformConfig;
        this.parameters=new TransformerParametersViewModel();
        if (transformConfig) {
          this.farmType = transformConfig.farmType ?? transformViewModel.transform.dataFarmType;
          this.sourceColumn = transformConfig.defSourceField;
          this.targetColumn = transformConfig.defTargetField;
          this.userColumn = transformConfig.userField;
          
          this.deleteMisses = transformConfig.delMisses;
          this.missName = transformConfig.missesNamed;
          this.sampleEnd = transformConfig.sampleEnd+ 1;
          this.sampleStart = transformConfig.sampleStart+ 1;
          this.timeColumn = transformConfig.timestampField;
          this.runAll = transformConfig.runAll;
          this.sortInfo = transformConfig.sortInfo;
          if(transformConfig.includeInResults){
            this.includeInResults = transformConfig.includeInResults.map(item =>new IncludeInfo(item));
            this.parameters.includeInResults=this.includeInResults;
          }
          this.isCloseField = transformConfig.isCloseField;
          this.isOpenField = transformConfig.isOpenField;
          this.orderField = transformConfig.orderField;
          this.defTimeout = transformConfig.defTimeout;
          this.defContainsInclude = transformConfig.defContainsInclude;
          //parameters
          this.parameters.sourceColumn= transformConfig.defSourceField;
          this.parameters.targetColumn= transformConfig.defTargetField;
          this.parameters.userColumn= transformConfig.userField;
          this.parameters.timeColumn= transformConfig.timestampField;
          this.parameters.sortInfo= transformConfig.sortInfo;
          //this.parameters.includeInResults= transformConfig.in;
          this.parameters.sampleStart = transformConfig.sampleStart+ 1;
          this.parameters.sampleEnd = transformConfig.sampleEnd+ 1;
          this.parameters.runAll= transformConfig.runAll;
          this.parameters.deleteMisses = transformConfig.delMisses;
          this.parameters.missName= transformConfig.missesNamed;
    
          // advanced settings
          this.bufferRows = transformConfig.bufferRows;
          this.threads = transformConfig.threads;
          this.multiTargetColumn = transformConfig.multiColumnTarget;
          this.groupBy = transformConfig.groupBy;
          this.noGroupId = transformConfig.noGroupId;
          // this.noGroupIdTimeout = transformConfig.noGroupIdTimeout;
          if(!transformConfig.separateBy){
            this.separateBy ="None";
          }else{
            this.separateBy = transformConfig.separateBy;
          }
          
          if (transformConfig.rules) {
            this.rules = transformConfig.rules.map(r => new ActivityNamingRuleViewModel(r));
          }

          
          // default
          if (!this.timeColumn || this.timeColumn?.length === 0) {
            this.timeColumn = this.getDefaultTimestampColumn();
          }
        }
    }

    override configureValidationInfo(): ValidationInfo[] {
      const infos = [];

      infos.push( new RequiredFieldValidation('groupByField', 'Group By'));
      infos.push( new RequiredFieldValidation('bufferRows', 'Buffer Rows'));
      infos.push( new RequiredFieldValidation('threads', 'Threads (0 > Auto)'));
      infos.push( new RequiredFieldValidation('noGroupId', 'Empty Group By Value'));
      // infos.push( new RequiredFieldValidation('noGroupIdTimeout', 'Empty Group By Timeout (s)'));
      infos.push( new RequiredFieldValidation('orderField', 'Order Field'));
      infos.push( new RequiredFieldValidation('isOpenField', 'Is Open Field'));
      infos.push( new RequiredFieldValidation('isCloseField', 'Is Close Field'));
      
      return infos;
    }

    reindexRules(): void {
      for (let i = 0; i < this.rules.length; i++) {
        this.rules[i].index = i + 1;
      }
      this.rules.sort((a, b) => a.index - b.index);
    }

    public override toTransformConfig(): ActivityNamingTransformConfig {
      const config = new ActivityNamingTransformConfig();
      config.farmType = this.farmType;
      config.transformType = TransformType.activityNamer;
      config.defSourceField=this.parameters.sourceColumn;
      config.defTargetField=this.parameters.targetColumn;
      config.userField=this.parameters.userColumn;
      config.timestampField=this.parameters.timeColumn;
      if(this.parameters.sortInfo){
        if(this.parameters.sortInfo.length==0){
          config.sortInfo =undefined;
        }else{
          config.sortInfo=this.parameters.sortInfo;
        }
      }
      if(this.parameters.includeInResults){
        if(this.parameters.includeInResults.length==0){
          config.includeInResults =undefined;
        }else{
          config.includeInResults =this.parameters.includeInResults.map(item => item.includeField);
        }
      }
      config.sampleStart =this.parameters.sampleStart-1;
      config.sampleEnd =this.parameters.sampleEnd-1;
      config.runAll=this.parameters.runAll;
      config.delMisses=this.parameters.deleteMisses;
      config.missesNamed=this.parameters.missName;

      config.groupBy = this.groupBy;
      config.defContainsInclude = this.defContainsInclude;
      config.defTimeout = this.defTimeout;
      config.bufferRows = this.bufferRows;
      config.threads = this.threads;
      config.isOpenField = this.isOpenField;
      config.isCloseField = this.isCloseField;
      config.orderField = this.orderField;
      if(this.separateBy=="None"){
        config.separateBy = undefined;
      }else{
        config.separateBy = this.separateBy;
      }
      config.noGroupId = this.noGroupId;
      // config.noGroupIdTimeout = this.noGroupIdTimeout;
      config.multiColumnTarget = this.multiTargetColumn;

      config.rules = this.rules.map(r => {
        const rule = r.toRule();
        rule.targetField = config.defTargetField;
        return rule;
      });

      return config;
    }

    public override onTransformRunCompleted(response: ActivityNamingTransformPreviewDataResponse): void {
      // A cache-hit run carries no stats at all (they're deliberately stripped
      // before a CachedProcessingResult is persisted -- see
      // project_stats_vs_fullrun_separation memory). Nothing has changed since
      // whatever last populated the stats currently on screen, so they're still
      // accurate -- leave them exactly as they are instead of wiping them blank.
      if (
        !response?.previewStats ||
        !response?.totalStats ||
        !response.totalStats.globalStat ||
        !response.totalStats.ruleStats ||
        !response.previewStats.globalStat ||
        !response.previewStats.ruleStats
      ) {
        return;
      }

      // Clear all stats prior to rebinding new values
      this.groupHitCount = null;
      this.hitCount = null;
      this.hitRatio = null;
      this.missCount = null;
      this.hitRatioDisplay ="0.00%";
      this.rows = 0;
      this.rules.forEach( r => {
        r.groupHits = null;
        r.rowHits = null;
        r.sampleGroupHits = null;
        r.sampleRowHits = null;
      });

      if (this.parameters.runAll) {
        // Map Transform Global and Rule stats
        this.groupHitCount = response.totalStats?.globalStat.groupHits;
        this.hitCount = response.totalStats?.globalStat.rowHits;
        
        if (response.totalStats?.globalStat.hitRate) {
          this.hitRatio = response.previewStats.globalStat.hitRate;
          this.hitRatioDisplay = `${(this.hitRatio * 100).toFixed(2)}%`;
        }
        this.missCount = response.totalStats?.globalStat.rowMisses;
      } else {
        // Map Transform Global and Rule stats
        this.groupHitCount = response.previewStats?.globalStat.groupHits;
        this.hitCount = response.previewStats.globalStat.rowHits;
        
        if (response.previewStats.globalStat.hitRate) {
          this.hitRatio = response.previewStats.globalStat.hitRate;
          this.hitRatioDisplay = `${(this.hitRatio * 100).toFixed(2)}%`;
        }
        this.missCount = response.previewStats.globalStat.rowMisses;
      }
      
      this.rows = this.parameters.runAll ? response.currentData?.totalRows : response.activeData?.totalRows;
      // map the rule stats to the rule
      if (response.previewStats.ruleStats) {
        for (let i = 0; i < this.rules.length; i++) {
          const ruleStat = response.previewStats.ruleStats.find(r => r.ruleIndex === i);
          this.rules[i].sampleGroupHits = ruleStat?.groupHits;
          this.rules[i].sampleRowHits = ruleStat?.rowHits;
        }
      }
      // map the rule stats to the rule
      if (response.totalStats.ruleStats) {
        for (let i = 0; i < this.rules.length; i++) {
          const ruleStat = response.totalStats.ruleStats.find(r => r.ruleIndex === i);
          this.rules[i].groupHits = ruleStat?.groupHits;
          this.rules[i].rowHits = ruleStat?.rowHits;
        }
      }
    }
}

export class GroupStartAtTypeUtil {
    static toString(ruleType: ActivityNamingRuleType): string {
        switch (ruleType) {
          case ActivityNamingRuleType.group: return 'Group Start';
          case ActivityNamingRuleType.contains: return 'Contains';
          case ActivityNamingRuleType.emptyGroup: return 'Empty Group By';
        }
    }
}

export class GroupEndAtTypeUtil {
    static toString(ruleType: ActivityNamingRuleType): string {
        switch (ruleType) {
          case ActivityNamingRuleType.group: return 'Group End';
          case ActivityNamingRuleType.contains: return 'Contains';
          case ActivityNamingRuleType.emptyGroup: return 'Empty Group By';
        }
    }
}